@let isAdmin = user?.customer_admin;
<div class="dashboard">
    <div class="row mt-4">
        <div class="col-md-48 col-lg-36">
            <div class="card panel-monsido-card">
                <mon-panel-header-next [faIcon]="'fas fa-globe text-link'"
                                  [pHeader]="'Domain Overview' | translate"
                                  [subHeader]="subheaderTranslation"
                                  data-test="page-header">
                    <div class="d-flex align-items-center">
                        <filter-button
                                [showFiltersBtn]="showFilters"
                                [(isFiltersOpen)]="isFiltersOpen"
                                data-test="filter-button">
                        </filter-button>
                        <table-search [(model)]="search"
                                      class="domain-overview-table-search"
                                      (getPage)="onSearch($event)"
                                      data-test="general-search-input">
                        </table-search>
                        @if (isAdmin) {
                            <button class="btn btn-border-radius btn-secondary ml-2"
                                    (click)="createDomain()">
                                <span class="fas fa-plus mr-1"></span><span translate>Add domain</span>
                            </button>
                        }
                    </div>
                    <div slot="header-new-line">
                        @if (isAdmin) {
                            <div class="text-right mt-3">
                                <div><span class="text-bold" translate>Total pages scanned</span>:<span class="ml-1">{{ (this.customer?.html_pages_count || 0) | monNumber }}</span></div>
                                <div><span class="text-bold" translate>Total documents scanned</span>:<span class="ml-1">{{ (this.customer?.documents_count || 0) | monNumber }}</span></div>
                            </div>
                        }
                    </div>
                </mon-panel-header-next>
                <div class="card-body" [ngClass]="{'pt-0': isAdmin}">
                    <projects-and-domains (onPageChange)="onPageChange($event)"
                                          (onPerPageChange)="onPageSizeChange($event)"
                                          (getPage)="getPage($event)"
                                          (createDomain)="createDomain($event)"
                                          [progress]="promise"
                                          [domainObservable]="domainObservable"
                                          [sort]="currentSort"
                                          (onSort)="onSortPage($event.direction, $event.by)"
                                          [(isFiltersOpen)]="isFiltersOpen"
                                          (onFiltersChanges)="onFiltersChanges($event)"
                                          [(filters)]="filters"
                                          [availableFilters]="availableFilters"
                    />
                </div>
                <div class="card-footer" *ngIf="showVersion">
                    Acquia Web Governance frontend version: {{ version }}
                </div>
            </div>
        </div>
        <div class="col-md-48 col-lg-12">
            <extension-guide-panel *ngIf="hasExtension === false"></extension-guide-panel>
        </div>
    </div>
</div>
